import React from 'react';
import ReactMarkdown, { defaultUrlTransform } from 'react-markdown';

import { InfoCard } from '@eika/card';
import { Link } from '@eika/link';
import { RichIcon } from '@eika/rich-icon';

import { useConfig } from '../../config';
import { CardType } from '../../types/generated-types';
import { assertUnreachable } from '../../utils/compiler-utils';
import { getUrl } from '../link-item/link-item-utils';
import { CurrentCardSporsmal } from './card-types';

import './card.scss';

const urlTransform = (link: string) => (/^tel:/.test(link) ? link : defaultUrlTransform(link));

interface CardProps {
    currentSporsmal: CurrentCardSporsmal;
}

export const Card = ({ currentSporsmal }: CardProps) => {
    const { cardType, richIconType, linkItem, id, tittel, text } = currentSporsmal.sporsmal;
    const { minside, glasskadeverksted } = useConfig().links;

    switch (cardType) {
        case CardType.Info:
            return (
                <div className="container__standard-width">
                    <InfoCard id={id} title={tittel} skipBackground>
                        {richIconType && <RichIcon type={richIconType} />}
                        <h3>{tittel}</h3>
                        <ReactMarkdown>{text}</ReactMarkdown>
                        {linkItem && (
                            <Link
                                href={getUrl(linkItem, minside.url, glasskadeverksted.url)}
                                linkType={linkItem.linkType}
                                target={linkItem.link.urlType === 'ExternalLink' ? '_blank' : '_self'}
                            >
                                {linkItem.tekst}
                            </Link>
                        )}
                    </InfoCard>
                </div>
            );
        case CardType.NoticeCard:
            return (
                <div className="container__standard-width">
                    <article id={id} className="card--notice-card">
                        <b>{tittel}</b>
                        <ReactMarkdown urlTransform={urlTransform}>{text}</ReactMarkdown>
                        {linkItem && (
                            <Link
                                href={getUrl(linkItem, minside.url, glasskadeverksted.url)}
                                linkType={linkItem.linkType}
                            >
                                {linkItem.tekst}
                            </Link>
                        )}
                    </article>
                </div>
            );
        default:
            return assertUnreachable(cardType);
    }
};
